import React, { Component } from 'react';

const play = process.env.PUBLIC_URL + '/img/button_appstore_android.svg';
const apple = process.env.PUBLIC_URL + '/img/button_appstore_apple.svg';
const windows = process.env.PUBLIC_URL + '/img/button_appstore_windows.svg';
const amazon = process.env.PUBLIC_URL + '/img/amazon.png';
const escolha = process.env.PUBLIC_URL + '/img/escolhaappstore.svg';
const huawei = process.env.PUBLIC_URL + '/img/huawei.png';


export default () => {
    return (


        <ul className="lista lista-lojas clearfix">


            <li>
                <a href="http://www.escolhatecnologia.com.br/appstore" target="_blank" ><img src={escolha} /></a>
            </li>
            <li>
                <a href="https://play.google.com/store/apps/dev?id=5978392300521042263" target="_blank" ><img src={play} /></a>
            </li>
            <li>
                <a href="https://itunes.apple.com/br/developer/escolha-tecnologia-ltda-me/id962923724" target="_blank" ><img src={apple} /></a>
            </li>
            <li>
                <a href="https://www.microsoft.com/pt-br/store/p/voz-da-mulher-do-tradutor/9nblgggxwrss?rtc=1" target="_blank" ><img src={windows} /></a>
            </li>
            <li>
                <a href="https://www.amazon.com.br/s?ie=UTF8&field-brandtextbin=Escolha%20Tecnologia&index=mobile-apps&search-type=ss" target="_blank" ><img src={amazon} /></a>
            </li>

            <li>
                <a href="https://appgallery.huawei.com/#/app/C101692775" target="_blank" ><img src={huawei} /></a>
            </li>
        </ul>


    );
}
